import React, { useState } from 'react';
import { Box, CssBaseline, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

const Layout = ({ children }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#F4F6F8' }}>
            <CssBaseline />

            {/* Sidebar */}
            <Box
                component="nav"
                sx={{
                    width: { md: 280 },
                    flexShrink: { md: 0 },
                }}
            >
                <Sidebar
                    isMobile={!isDesktop}
                    isOpen={isSidebarOpen}
                    onClose={() => setIsSidebarOpen(false)}
                    onToggle={toggleSidebar}
                />
            </Box>

            {/* Main Content Wrapper */}
            <Box
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    width: { md: `calc(100% - 280px)` },
                    minHeight: '100vh',
                }}
            >
                {/* Header */}
                <Header onMenuClick={toggleSidebar} isMobile={!isDesktop} />

                {/* Main Content */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                        overflow: 'auto',
                    }}
                >
                    <Outlet />
                </Box>

                {/* Footer */}
                <Footer />
            </Box>
        </Box>
    );
};

export default Layout;
